module.exports = __webpack_public_path__ + "img/luxury-homepage-quick-links-infiniti.d3c0aa58.png";